import Cookie from 'js-cookie';
import { createI18n } from 'vue-i18n/dist/vue-i18n.esm-bundler.js';
import en from '../translations/trans.en.json';
import es from '../translations/trans.es.json';

const locale: string = Cookie.get( 'locale' ) || 'en';

Cookie.set( 'locale', locale, {
    expires: 3,
    sameSite: 'Strict',
} );

const i18n = createI18n( {
    fallbackLocale: 'en',
    locale: locale,
    silentTranslationWarn: import.meta.env.PROD,
    messages: {
        en: en,
        es: es,
    },
    legacy: false,
} );

export {
    i18n,
};
